import { Link, FormGroup } from "frno-react";
import DynamicText from "../../common/DynamicText";
import useTextStore from "../../../state/TextStore";
import useApplicationStore from "../../../state/ApplicationStore";
import useDataStore from "../../../state/DataStore";
import { useEffect, useState } from "react";
import { TableType } from "../../../data/TableType";
import InputField from "../../common/Inputfield";

type UserDataProps = {
  tableType: TableType;
  idPrefix: "mobile-" | "desktop-";
};
export default function UserData({ tableType, idPrefix }: UserDataProps) {
  const { getTextByKey } = useTextStore();

  const {
    selectedCompany,
    setSelectedCompany,
    savingsValue,
    setSavingsValue,
    updateAutoScroll,
  } = useApplicationStore();

  const { getSelectableCompanies } = useDataStore();

  const selectableCompanies = getSelectableCompanies(tableType).map(
    (company) => ({
      value: company,
      label: company,
    }),
  );

  selectableCompanies.unshift({
    value: "",
    label: getTextByKey("filter.userinput.selectcompany.option.defaultvalue"),
  });

  function formatValue(inputValue: number | null) {
    if (inputValue) {
      const formatter = new Intl.NumberFormat("no-NO");
      return formatter.format(inputValue);
    }
    return "";
  }

  const [formattedValue, setFormattedValue] = useState(
    formatValue(savingsValue),
  );

  useEffect(() => {
    setFormattedValue(formatValue(savingsValue));
  }, [savingsValue]);

  const handleOptionChange = (value: string) => {
    setSelectedCompany(value);
    updateAutoScroll(true);
  };

  const handleSavingsamountChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const rawValue = event.target.value;

    const inputValue = rawValue.replace(/[^0-9]/g, "");
    setSavingsValue(Number.parseInt(inputValue) || 0);
  };

  return (
    <>
      <div className="mt-8">
        <InputField
          id={`${idPrefix}sparesaldo`}
          suffix="kr"
          min={0}
          max={1000000000}
          value={formattedValue}
          placeholder="10000"
          label={getTextByKey("filter.userinput.savingsamount.label")}
          onChange={handleSavingsamountChange}
        />
      </div>

      <div className="mt-8">
        <FormGroup
          type="select"
          label={getTextByKey("filter.userinput.selectcompany.label")}
          onChange={(e) => handleOptionChange(e.target.value)}
          value={selectedCompany}
          options={selectableCompanies}
        />
      </div>
      <div className="mt-4">
        <DynamicText
          textKey="filter.userinput.link.wrapper"
          replaceComponent={
            <Link
              href="https://norskpensjon.no/"
              target="_blank"
              linkText={getTextByKey("filter.userinput.link.text")}
            />
          }
        />
      </div>
    </>
  );
}
